<template>
  <form @submit.prevent="add">
    <button v-if="!activeForm" @click.prevent="open" class="addScrapbookButton">New Scrapbook</button>
    <div v-if="activeForm">
      <label>
        Name:
        <input ref="iteminput" type="text" v-model="scrapbook" />
      </label>
      <input type="submit" value="Add" />
    </div>
  </form>
</template>

<script>
import DataScrapbooks from "@/js/data/controllers/DataScrapbooks.js";

export default {
  name: 'scrapbook-add',
  data () {
    return {
      activeForm: false,
      scrapbook: ''
    }
  },
  props: ['item'],
  methods: {
    async add () {
      if (this.scrapbook == '') {
        alert('name is required')
        this.$refs.iteminput.focus()
        return
      }

      let params = {name: this.scrapbook}
      let result = await DataScrapbooks.add(params)
      if (result.name && result.name == "Error") {
        console.log(result.message)
        alert('You already have a scrapbook with this name')
        this.$refs.iteminput.focus()
        return
      }

      if (this.item) {
        let params = {
          scrapbook_id: result.id,
          item_id: this.item.id
        }
        DataScrapbooks.addItemToScrapbook(params);
      }

      this.activeForm = false
    },
    open () {
      this.activeForm = true
      this.$nextTick(() => {
        this.$refs.iteminput.focus()
      })

    }
  }

}
</script>

<style scoped>
  input[type="submit"] {
    margin-left: 10px;
  }
  input {
    margin-bottom: 10px;
    max-width: calc(100% - 40px);
  }
</style>
